import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileuploaderFilepondService {

  public fileRemovedFinished = new Subject<any>();

  loadedBlob: File;
  fileName: string;
  fileLoaded: boolean = false;

  readFileContent(file: File) {
    this.loadedBlob = file;
    this.fileName = file.name;
    let fileReader: FileReader = new FileReader();
    
    fileReader.readAsArrayBuffer(file);
    return Observable.create(observer => {
      fileReader.onloadend = () => {
        observer.next(fileReader.result);
        
        observer.complete();
      };
    });      
  }

  fileContentLoaded() {
    this.fileLoaded = true;
  }

  fileRemoved() {
    this.fileLoaded = false;
    this.fileRemovedFinished.next("");
  }

  getLoadedBlob() {
    return this.loadedBlob as Blob;
  }

  getFileName() {
    return this.fileName;
  }

  hasFileLoaded()
  {
    return this.fileLoaded;
  }
}
